import React, { useRef, useState, useLayoutEffect, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './style.module.css';
import TooltipOnro from '../Tooltip';
import Typography from '../Typography';

const ellipsisDefaultStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordBreak: 'break-all',
};

const EllipisWithTooltip = ({ style = {}, children, forceTooltip, maxWidth }) => {
  const containerRef = useRef(null);
  const [checked, setChecked] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);

  const ellipsisStyle = { ...ellipsisDefaultStyle, ...style };

  useLayoutEffect(() => {

    const el = containerRef.current;


    if (!el) return;



    if (forceTooltip) {
      if (el.clientWidth > maxWidth) {
        setHasOverflow(true);
        setChecked(true)
      } else {
        setHasOverflow(el.scrollWidth > el.clientWidth);
        setChecked(true)
      }

    } else {

      setHasOverflow(el.scrollWidth > el.clientWidth);
      setChecked(true)
    }

    ;
  }, [children]);


  useEffect(() => {
    setChecked(false)
    setHasOverflow(false);
    

    const el = containerRef.current;


    if (!el) return;



    if (forceTooltip) {
      if (el.clientWidth > maxWidth) {
        setHasOverflow(true);
        setChecked(true)
      } else {
        setHasOverflow(el.scrollWidth > el.clientWidth);
        setChecked(true)
      }

    } else {

      setHasOverflow(el.scrollWidth > el.clientWidth);
      setChecked(true)
    }

  }, [children])


  console.log("useLayoutEffect ss ", checked, hasOverflow)


  // مرحله اول: هنوز overflow مشخص نشده
  if (!checked) {
    return (
      <div ref={containerRef} style={ellipsisStyle}>
        {children}
      </div>
    );
  }

  // مرحله دوم: overflow ندارد → wrapper حذف شود
  if (!hasOverflow) {
    return children;
  }

  // مرحله سوم: overflow دارد → tooltip + ellipsis
  return (
    <TooltipOnro
      open={true}
      tooltipClassName={styles.TooltipOnro}
      placement="top"
      title={
        <Typography
          style={{ padding: '7px' }}
          weight="Body_Small_Medium"
          text={children}
        />
      }
    >
      <div ref={containerRef} style={ellipsisStyle} className='ellipsssss'>
        {children}
      </div>
    </TooltipOnro>
  );
};

EllipisWithTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

export default EllipisWithTooltip;
